import React from "react";
import IMAGES from "../Images";
import Heading from "./Heading";
import Paragraph from "./Paragraph";
import styled from "styled-components";
import { MainContainer, WeHelpItem } from "../assets/styles/theme/styles";
import theme from "../assets/styles/theme/theme";
import LinkComponent from "./Link";

const HeroContainer = styled.div`
  /* add styles for hero container */
`;

const HeroItem = styled.div`
  /* add styles for hero item */
  margin-bottom: 1rem;
`;

const WeHelpContainer = styled.div`
  display: grid;
  gap: 2rem;
  text-align: left;
  padding: 15px 0px;

  @media (min-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1020px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;
  }
`;

// const WeHelpItem = styled.div`
//   color: ${theme.colors.secondary};
//   text-align: center;

//   @media (min-width: 1020px) {
//     text-align: left;
//   }
// `;

export default function GridTextContainer({ heading, helpContent, link }) {
  return (
    <>
      <HeroContainer>
        <MainContainer>
          <HeroItem>
            <Heading level={1}>{heading}</Heading>
          </HeroItem>
          <WeHelpContainer>
            {helpContent.map((content, index) => (
              <WeHelpItem key={index}>
                <Heading level={3}>{content.title}</Heading>
                <Paragraph level={2}>{content.description}</Paragraph>
                {link && <LinkComponent text="Learn more" />}
              </WeHelpItem>
            ))}
          </WeHelpContainer>
        </MainContainer>
      </HeroContainer>
    </>
  );
}

// GridTextContainer , IndustryItDiv2: ye dono ki styling same hai.
